// Port of addslashes() method from PHP standard library
//
// http://php.net/manual/en/function.addslashes.php
import { toNumber } from 'lodash';

const addSlashes = (string = '') => {
  return string
    .replace(/\\/g, '\\\\')
    .replace(/\'/g, "\\'")
    .replace(/\"/g, '\\"')
    .replace(/\0/g, '\\0');
};

// fraction can be NaN or Infinity - will be coerced to 0 by ~~ operator.
const formatPercentage = (fraction: number, decimalDigits: number = 1) => {
  const percentValue = ~~(fraction * 1000) / 10;
  return percentValue === 0 ? '0' : percentValue.toFixed(decimalDigits);
};

const getFormatPercentageWithSign = (sign = '%') => {
  return (...args: Parameters<typeof formatPercentage>) =>
    `${formatPercentage(...args)}${sign}`;
};

export { addSlashes, formatPercentage, getFormatPercentageWithSign };

const formatPercentageWithSign = getFormatPercentageWithSign();

export const numFormatter = {
  percent(num: number = 0) {
    return formatPercentageWithSign(num / 100);
  },
  int(num: number = 0) {
    return Intl.NumberFormat().format(toNumber(num));
  },
};
